import { render, staticRenderFns } from "./CompetitionEventsCalendarOld.vue?vue&type=template&id=5f8aaec3&scoped=true"
import script from "./CompetitionEventsCalendarOld.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitionEventsCalendarOld.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompetitionEventsCalendarOld.vue?vue&type=style&index=0&id=5f8aaec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8aaec3",
  null
  
)

export default component.exports